import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AdminRoute } from './components/AdminRoute.js';
import { Layout } from './components/Layout.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { RequireEntitlement } from './components/RequireEntitlement.js';
import { RequireSetupComplete } from './components/RequireSetupComplete.js';
import { Admin } from './pages/Admin.js';
import { AuthCallback } from './pages/AuthCallback.js';
import { Billing } from './pages/Billing.js';
import { Calendar } from './pages/Calendar.js';
import { Dashboard } from './pages/Dashboard.js';
import { History } from './pages/History.js';
import { Log } from './pages/Log.js';
import { Login } from './pages/Login.js';
import { ActivityScreen } from './pages/onboarding/ActivityScreen.js';
import { BodyStatsScreen } from './pages/onboarding/BodyStatsScreen.js';
import { GoalLockScreen } from './pages/onboarding/GoalLockScreen.js';
import { ModeScreen } from './pages/onboarding/ModeScreen.js';
import { OnboardingLayout } from './pages/onboarding/OnboardingLayout.js';
import { SummaryScreen } from './pages/onboarding/SummaryScreen.js';
import { TrainingScreen } from './pages/onboarding/TrainingScreen.js';
import { Profile } from './pages/Profile.js';
import { Review } from './pages/Review.js';
import { RoutineEditor } from './pages/RoutineEditor.js';
import { Routines } from './pages/Routines.js';
import { Stats } from './pages/Stats.js';
import { Workout } from './pages/Workout.js';
import { WorkoutDetail } from './pages/WorkoutDetail.js';
import { WorkoutSession } from './pages/WorkoutSession.js';

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  { path: '/auth/callback', element: <AuthCallback /> },
  {
    path: '/admin/*',
    element: (
      <ProtectedRoute>
        <AdminRoute>
          <Admin />
        </AdminRoute>
      </ProtectedRoute>
    ),
  },
  {
    element: (
      <ProtectedRoute>
        <RequireSetupComplete>
          <RequireEntitlement>
            <Layout />
          </RequireEntitlement>
        </RequireSetupComplete>
      </ProtectedRoute>
    ),
    children: [
      { path: '/', element: <Navigate to="/dashboard" replace /> },
      { path: '/dashboard', element: <Dashboard /> },
      { path: '/workout/new', element: <Workout /> },
      // Active session lives at its own route so a user navigating to /workout
      // mid-session goes to the start screen (and can choose to resume).
      { path: '/workout/active', element: <WorkoutSession /> },
      { path: '/routines', element: <Routines /> },
      { path: '/routines/new', element: <RoutineEditor /> },
      { path: '/routines/edit/:id', element: <RoutineEditor /> },
      { path: '/history', element: <History /> },
      { path: '/history/:id', element: <WorkoutDetail /> },
      { path: '/stats', element: <Stats /> },
      { path: '/profile', element: <Profile /> },
      { path: '/calendar', element: <Calendar /> },
      { path: '/plan/review', element: <Navigate to="/routines" replace /> },
      { path: '/diet/review', element: <Navigate to="/log" replace /> },
      { path: '/diet/select', element: <Navigate to="/log" replace /> },
      { path: '/routine/select', element: <Navigate to="/routines" replace /> },
      { path: '/log', element: <Log /> },
      { path: '/review', element: <Review /> },
    ],
  },
  {
    path: '/subscribe',
    element: (
      <ProtectedRoute>
        <RequireSetupComplete>
          <Billing />
        </RequireSetupComplete>
      </ProtectedRoute>
    ),
  },
  {
    path: '/billing',
    element: (
      <ProtectedRoute>
        <RequireSetupComplete>
          <Billing />
        </RequireSetupComplete>
      </ProtectedRoute>
    ),
  },
  {
    element: (
      <ProtectedRoute>
        <OnboardingLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: '/onboarding', element: <Navigate to="/onboarding/mode" replace /> },
      { path: '/onboarding/mode', element: <ModeScreen /> },
      { path: '/onboarding/goal', element: <GoalLockScreen /> },
      { path: '/onboarding/body-stats', element: <BodyStatsScreen /> },
      { path: '/onboarding/activity', element: <ActivityScreen /> },
      { path: '/onboarding/training', element: <TrainingScreen /> },
      { path: '/onboarding/summary', element: <SummaryScreen /> },
    ],
  },
  { path: '/diet/preferences/*', element: <Navigate to="/log" replace /> },
  { path: '*', element: <Navigate to="/dashboard" replace /> },
]);
